import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { ComparisonChartComponent } from './components/comparison-chart/comparison-chart.component';
import { GraphDiagramComponent } from './components/graph-diagram/graph-diagram.component';
import { SankeyDiagramComponent } from './components/sankey-diagram/sankey-diagram.component';
import * as echarts from './echart-modules';
import { PopupMenuModule } from 'studio-components/popup-menu/popup-menu.module';
import { IconModule } from '../../../studio-components/src/icon/public-api';
import { ButtonLegacyModule } from '../button-legacy/public-api';
import { ChartValueFormatterService } from './services/chart-value-formatter.service';

export const chartModules = async () => echarts;

@NgModule({
  declarations: [
    LineChartComponent,
    ComparisonChartComponent,
    GraphDiagramComponent,
    SankeyDiagramComponent,
  ],
  imports: [
    CommonModule,
    PopupMenuModule,
    ButtonLegacyModule,
    IconModule,
    NgxEchartsModule.forRoot({
      echarts: chartModules,
    }),
  ],
  providers: [ChartValueFormatterService],
  exports: [
    LineChartComponent,
    ComparisonChartComponent,
    GraphDiagramComponent,
    SankeyDiagramComponent,
  ],
})
export class ChartModule {}
